import { Button, Grid, Menu } from "@material-ui/core";
import React from "react";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  HighlightOffRounded as HighlightOffRoundedIcon,
} from "@material-ui/icons";
import { isEmpty, isEqual, isFunction } from "lodash";

import DatePickerAtom from "../date-picker-v2";
import "./style.css";

const DateRangeSelectorFilter = ({ meta, value, onChange }) => {
  const [anchorElement, setAnchorElement] = React.useState(null);
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);

  const handleClose = () => {
    setAnchorElement(null);
  };

  const handleClick = (event) => {
    setAnchorElement(event.currentTarget);
  };

  const onClickReset = () => {
    setFromDate("");
    setToDate("");
  };

  React.useEffect(() => {
    if (isFunction(onChange)) {
      const output = { fromDate: "", toDate: "" };
      if (isEmpty(fromDate) || isEmpty(toDate)) {
        onChange(output);
        return;
      }
      output.fromDate = fromDate;
      output.toDate = toDate;
      if (!isEqual(value, output)) {
        onChange(output);
      }
    }
  }, [fromDate, onChange, toDate, value]);

  const label = meta.label;
  const elementId = meta.elementId;

  const menuElementId = `${elementId}-menu`;
  const buttonElementId = `${elementId}-button`;
  const showMenuDropdown = Boolean(anchorElement);
  const hasValidValue = !isEmpty(fromDate) && !isEmpty(toDate);

  return (
    <Grid container direction="row" className="date-range-selector-filter">
      <Button
        id={buttonElementId}
        variant="contained"
        size="medium"
        className="outer-action-button"
        startIcon={
          hasValidValue ? (
            <HighlightOffRoundedIcon
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onClickReset();
              }}
            />
          ) : (
            <AddCircleOutlineIcon />
          )
        }
        aria-controls={showMenuDropdown ? menuElementId : undefined}
        aria-haspopup="true"
        aria-expanded={showMenuDropdown ? "true" : undefined}
        disableElevation
        onClick={handleClick}
      >
        {label}
        {hasValidValue && (
          <>
            <span className="seleted-values">{`from ${fromDate}`}</span>
            <span className="seleted-values">{`to ${toDate}`}</span>
          </>
        )}
      </Button>
      <Menu
        id={menuElementId}
        anchorEl={anchorElement}
        open={showMenuDropdown}
        elevation={2}
        onClose={handleClose}
        keepMounted
        variant="selectedMenu"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        PaperProps={{
          style: {
            paddingBlock: 16,
            paddingInline: 8,
            height: 320,
            width: 400,
          },
        }}
        slotProps={{
          list: {
            "aria-labelledby": buttonElementId,
          },
        }}
      >
        <Grid
          container
          direction="column"
          className="menu-content-container gap-y-16"
        >
          <Grid container direction="row" className="gap-x-8">
            <DatePickerAtom
              value={fromDate}
              onChange={(date) => setFromDate(date)}
              label="from"
            />
            <DatePickerAtom
              value={toDate}
              onChange={(date) => setToDate(date)}
              label="to"
            />
          </Grid>
        </Grid>
      </Menu>
    </Grid>
  );
};

export default DateRangeSelectorFilter;
